import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react/macro";

import { Skeleton } from "@/shared/ui/skeleton";

import { useStatsSummary } from "../../api/useStatsSummary";

const SINCE = msg({
  message:
    "{count, plural, one {# match in history since {since}} other {# matches in history since {since}}}",
});

// Подпись у приветствия: сколько матчей в истории и с какого дня. Сводка грузится —
// заглушка; сводки ещё нет — ничего.
export const HistorySince = () => {
  const { i18n } = useLingui();
  const { data, isPending } = useStatsSummary();
  const summary = data?.summary;
  if (isPending) {
    return <Skeleton className="h-3.5 w-56" />;
  }
  if (summary == null || summary.matches === 0 || summary.first_match_at === null) {
    return null;
  }
  const since = new Intl.DateTimeFormat(i18n.locale, {
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(new Date(summary.first_match_at));
  return (
    <p className="text-[13px] text-subtle">
      {i18n._({ ...SINCE, values: { count: summary.matches, since } })}
    </p>
  );
};
